<template>
 <div class="app-container">
  <el-tabs v-model="activeName" @tab-click="handleTabClick" style="padding-left: 5px;">
    <el-tab-pane label="超时预警" name="one" >
       <div class="searchBox" ref="searchBox">
        <div class="searchBtnBox">
              <el-button type="primary"  v-if="btnFlg[0]"  @click="addRegion">新增</el-button>
        </div>
      </div>
      <!--  表格 -->
      <div class="table" :style="{height:h}">
        <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
        @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="操作"  width="120">
              <template slot-scope="scope">
                <el-button type="text" size="mini"  v-if="btnFlg[1]"  @click="modifyRegion(scope.row)">修改</el-button>
                <el-button type="text" size="mini" v-if="btnFlg[2]"  @click="delDeiver(scope.row)">删除</el-button>

              </template>
          </el-table-column>
          <el-table-column prop="showName" min-width="300"  :formatter="emptyFn" label="报警类型"></el-table-column>
          <el-table-column prop="remark" min-width="300"  :formatter="emptyFn" label="报警开始标准">
            <template scope="scope">
                  <div>
                    <span v-if="scope.row.itemNo==1">超过创建时间{{scope.row.remark}}小时</span>
                    <span v-if="scope.row.itemNo==2">超过装车时间{{scope.row.remark}}小时</span>
                    <span v-if="scope.row.itemNo==3">超过卸车时间{{scope.row.remark}}小时</span>
                    <span v-if="scope.row.itemNo==4">超过创建时间{{scope.row.remark}}小时</span>
                    <span v-if="scope.row.itemNo==5">超过流转时间{{scope.row.remark}}小时</span>
                     <span v-if="scope.row.itemNo==6">超过开票时间{{scope.row.remark}}小时</span>
                  </div>
                </template>
          </el-table-column>
          <el-table-column prop="createUser" min-width="120" :formatter="emptyFn" label="创建人"></el-table-column>
          <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[20,50,100]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 新建修改 -->
      <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="500px" center>
        <span>
          <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
          <div class="inpBox">
            <el-form-item label="报警类型:" prop="itemNo" >
              <el-select  v-model="addFrom.itemNo" filterable placeholder="请选择" @change="leixingChange">
                <el-option label="装车超时" value="1" ></el-option>
                <el-option label="卸车超时" value="2" ></el-option>
                <el-option label="签收超时" value="3" ></el-option>
                <el-option label="自有车调度操作超时" value="4" ></el-option>
                <el-option label="外部车调度操作超时" value="5" ></el-option>
                <el-option label="开票操作超时" value="6" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报警开始标准:" prop="remark"  class="shichang jiage" >
              <span>{{tishiyu}}</span><el-input placeholder="" v-number-input.float="0"  maxlength="20"  v-model.trim="addFrom.remark"></el-input>
              <span class="danwei">小时</span>
            </el-form-item>
          </div>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
        </span>
      </el-dialog>
    </el-tab-pane>
    <el-tab-pane label="司机车辆预警" name="two" >
      <el-form  :inline="true" :rules="rulesS"  ref="addFormS" :model="addFormS"  class="demo-form-inline jiaoyan"  label-width="150px"  size="mini"  >
        <div style="display: flex;     justify-content: space-between;">
          <div class="addressBox" style="margin-top:20px;width:48%; ">
            <h4 class="title">
              <span><i class="fa fa-user-circle-o iconFont" aria-hidden="true"></i>司机信息提醒设置：</span>
            </h4>
            <div style="margin-left:20px">
              <div>
                <el-form-item label="身份证到期提醒:" prop="identityFlag" class="jiage" >
                  <el-radio-group v-model="addFormS.identityFlag">
                    <el-radio-button label="0">开</el-radio-button>
                    <el-radio-button label="1">关</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="identityDays" class="jiage" v-if="addFormS.identityFlag=='0'" >
                  <el-input  placeholder="" maxlength="5" v-number-input.float="0"  v-model.trim="addFormS.identityDays"  ></el-input>
                  <span class="danwei">天</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="驾驶证到期提醒:" prop="licenseFlag" class="jiage" >
                  <el-radio-group v-model="addFormS.licenseFlag">
                    <el-radio-button label="0">开</el-radio-button>
                    <el-radio-button label="1">关</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="licenseDays" class="jiage" v-if="addFormS.licenseFlag=='0'">
                  <el-input  placeholder="" maxlength="5" v-number-input.float="0"  v-model.trim="addFormS.licenseDays"  ></el-input>
                  <span class="danwei">天</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="从业资格证到期提醒:" prop="qualificationFlag" class="jiage" >
                  <el-radio-group v-model="addFormS.qualificationFlag">
                    <el-radio-button label="0">开</el-radio-button>
                    <el-radio-button label="1">关</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="qualificationDays" class="jiage" v-if="addFormS.qualificationFlag=='0'">
                  <el-input  placeholder="" maxlength="5" v-number-input.float="0"  v-model.trim="addFormS.qualificationDays"  ></el-input>
                  <span class="danwei">天</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="保险到期提醒:" prop="driverInsuranceFlag" class="jiage" >
                  <el-radio-group v-model="addFormS.driverInsuranceFlag">
                    <el-radio-button label="0">开</el-radio-button>
                    <el-radio-button label="1">关</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="driverInsuranceDays" class="jiage" v-if="addFormS.driverInsuranceFlag=='0'">
                  <el-input  placeholder="" maxlength="5" v-number-input.float="0"  v-model.trim="addFormS.driverInsuranceDays"  ></el-input>
                  <span class="danwei">天</span>
                </el-form-item>
              </div>

            </div>
          </div>
          <div style="border-right:1px solid #ddd"></div>
          <div class="addressBox" style="margin-top:20px;width:48%; ">
            <h4 class="title">
              <span><i class="fa fa-car iconFont" aria-hidden="true"></i>车辆信息提醒设置：</span>
            </h4>
            <div style="margin-left:20px">
              <div>
                <el-form-item label="行驶证期到期提醒:" prop="drivingFlag" class="jiage" >
                  <el-radio-group v-model="addFormS.drivingFlag">
                    <el-radio-button label="0">开</el-radio-button>
                    <el-radio-button label="1">关</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="drivingDays" class="jiage" v-if="addFormS.drivingFlag=='0'">
                  <el-input  placeholder="" maxlength="5" v-number-input.float="0"  v-model.trim="addFormS.drivingDays"  ></el-input>
                  <span class="danwei">天</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="道路运输证到期提醒:" prop="transportFlag" class="jiage" >
                  <el-radio-group v-model="addFormS.transportFlag">
                    <el-radio-button label="0">开</el-radio-button>
                    <el-radio-button label="1">关</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="transportDays" class="jiage" v-if="addFormS.transportFlag=='0'">
                  <el-input  placeholder="" maxlength="5" v-number-input.float="0"  v-model.trim="addFormS.transportDays"  ></el-input>
                  <span class="danwei">天</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="车辆保险到期提醒:" prop="zhucheInsuranceFlag" class="jiage" >
                  <el-radio-group v-model="addFormS.zhucheInsuranceFlag">
                    <el-radio-button label="0">开</el-radio-button>
                    <el-radio-button label="1">关</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="zhucheInsuranceDays" class="jiage" v-if="addFormS.zhucheInsuranceFlag=='0'">
                  <el-input  placeholder="" maxlength="5" v-number-input.float="0"  v-model.trim="addFormS.zhucheInsuranceDays"  ></el-input>
                  <span class="danwei">天</span>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        </el-form>
        <div class="footerBtn">
          <el-button type="primary" class="bigBtn"  btnCode="004P001B000"  @click="saveFnS">保存</el-button>
        </div>
    </el-tab-pane>
  </el-tabs>

 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getDictionaryDetailList, addOrUpTimeoutReminder } from '@/api/newTMS'
import { getCurrUserDepartment, getCurrUserCompany } from '@/api/newCrm'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { tOverdueSetList, tOverdueSetUpdate } from '@/api/vgs-driver2.0'
export default {
  components: {

  },
  data () {
    return {
      activeName: 'one',
      isAdd: false,
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      title: '新增',
      dialogVisible: false,
      bumenList: [],
      zigsList: [], // 子公司列表
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        dictionaryType: 'timeout_reminder'
      },
      total: 0,
      loading: 'false',
      rules: {
        itemNo: [
          { required: true, message: '请选择报警类型', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请选择报警开始标准', trigger: 'blur' }
        ]

      },
      rulesS: {
        identityDays: [{ required: true, message: '请输入身份证到期提醒天数', trigger: ['blur', 'change'] }],
        licenseDays: [{ required: true, message: '请输入驾驶证到期提醒天数', trigger: ['blur', 'change'] }],
        qualificationDays: [{ required: true, message: '请输入从业资格证到期提醒天数', trigger: ['blur', 'change'] }],
        driverInsuranceDays: [{ required: true, message: '请输入司机保险到期提醒天数', trigger: ['blur', 'change'] }],
        drivingDays: [{ required: true, message: '请输入行驶证到期提醒天数', trigger: ['blur', 'change'] }],
        transportDays: [{ required: true, message: '请输入道路运输证到期提醒天数', trigger: ['blur', 'change'] }],
        zhucheInsuranceDays: [{ required: true, message: '请输入车辆保险期提醒天数', trigger: ['blur', 'change'] }],
        dayNum: [{ required: true, message: '请输入合同提醒天数', trigger: ['blur', 'change'] }]
      },
      addFrom: {},
      tishiyu: '',
      addFormS: {}, // 司机车辆预警
      btnFlg: [],
      btnIdArr: ['01N01A0100', '01N01A0200', '01N01A0300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    getCurrUserCompany().then(res => { this.zigsList = res })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 210) + 'px'
  },
  methods: {
    handleTabClick () {
      if (this.activeName == 'one') {

      } else if (this.activeName == 'two') {
        tOverdueSetList().then(res => {
          if (res.length > 0) {
            this.addFormS = res[0]
          }
        })
      }
    },
    saveFnS () {
      this.$refs.addFormS.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          tOverdueSetUpdate(this.addFormS).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.masterId = this.masterId
      getDictionaryDetailList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 报警类型更改
    leixingChange (e) {
      if (e == 1) {
        this.addFrom.showName = '装车超时'
        this.tishiyu = '超出创建时间时长'
      } else if (e == 2) {
        this.addFrom.showName = '卸车超时'
        this.tishiyu = '超出装车时间时长'
      } else if (e == 3) {
        this.addFrom.showName = '签收超时'
        this.tishiyu = '超出卸车时间时长'
      } else if (e == 4) {
        this.addFrom.showName = '自有车调度操作超时'
        this.tishiyu = '超出创建时间时长'
      } else if (e == 5) {
        this.addFrom.showName = '外部车调度操作超时'
        this.tishiyu = '超出流转时间时长'
      } else if (e == 6) {
        this.addFrom.showName = '开票操作超时'
        this.tishiyu = '超出开票时间时长'
      }
    },
    // 添加
    addRegion () {
      this.title = '新增'
      this.addFrom = {}
      this.dialogVisible = true
      this.addFrom.dictionaryType = 'timeout_reminder'
      this.addFrom.dictionaryName = '报警设置'
      this.addFrom.orderBy = 1
      this.isAdd = true
    },
    // 修改
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          addOrUpTimeoutReminder(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },

    // 删除
    delDeiver (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addOrUpTimeoutReminder({ detailId: row.detailId, delFlag: 1 }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        dictionaryType: 'timeout_reminder'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.shichang /deep/.el-input{
  width: 80px;
  .el-input__inner{
    width: 80px;
  }

}
</style>
